const initFadeInAnimations = () => {
    const elementsToAnimate = document.querySelectorAll("[data-animation]");
    // the IntersectionObserver is a js native function that exploits the "observable pattern"
    // and gives us an event when an html element enters the users's viewport.
    // instance new observer (event emitter)
    const observer = new IntersectionObserver((entries) => {
        //function that triggers once the event is observed
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add("active");
                    //animation delay
                }, 400);
            }
        });
    });
    //observe (event subscriber / obsever)
    elementsToAnimate.forEach((element) => {
        observer.observe(element);
    });
};
